import { State } from '@meraki-internal/state';
import { IAvatarPhotoColor, IAvatarPickerValue } from './PhotoAvatarOrColorPicker';

export interface IAvatarFormState {
    memberId?: string;
    avatar: IAvatarPickerValue;
}

export class AvatarFormState extends State<IAvatarFormState> {
    constructor(){
        super({
            memberId: undefined,
            avatar: {}
        });
    }
    init = ({ memberId, avatar }: { memberId: string; avatar: IAvatarPickerValue }) => {
        this.setState({ memberId, avatar });
    };

    clear = () => {
        this.setState({ memberId: undefined, avatar: {} });
    };

    setAvatar = (avatar: IAvatarPhotoColor) => {
        if (!this.state.memberId){
            throw new Error('init must be called first');
        }
        this.setState({ avatar });
    };

}
